import { useLocation } from "react-router-dom";
import React from "react";
import { useCart } from "../context/CartContext";
import { useLanguage } from "../context/LanguageContext";

const ProductSingleCard = ({
  product,
  isPublicView: explicitPublicView,
  index,
  onSelectImage,
}) => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { addToCart, removeFromCart, cartItems } = useCart();
  const { t } = useLanguage();

  const token = localStorage.getItem("token");
  const tokenAcesso = localStorage.getItem("tokenAcesso");
  const isValid = (t) => {
    if (!t) return false;
    const clean = t.replace(/^["']|["']$/g, "").trim();
    return clean !== "" && clean !== "undefined" && clean !== "null";
  };
  const isLogged = isValid(token) || isValid(tokenAcesso);
  const isPublicView = explicitPublicView ?? (!isLogged && !isHome);

  const itemInCart = cartItems.find((item) => item._id === product._id);

  const quantity = itemInCart ? itemInCart.quantity : 0;

  const isGift = Boolean(product.tags?.toLowerCase().includes("brinde"));

  const handleAddToCart = () => {
    addToCart(product);
  };

  const handleRemoveFromCart = () => {
    removeFromCart(product._id);
  };

  // Somente na home mostra as imagens (gifts) sem marca d'água (product.image).
  // Em qualquer outro lugar (na loja pública ou na área de compra), exibe sempre a versão com marca d'água (product.imageSample).
  const displayImage = isHome
    ? product.image
    : isPublicView
    ? product.imageSample || product.image
    : isGift
    ? product.image
    : product.imageSample;

  return (
    <div className="card-compact w-92 bg-base-200 rounded-sm shadow-xl">
      <figure
        className="relative overflow-hidden cursor-pointer group"
        onClick={() => onSelectImage && onSelectImage(product, index)}
        title="Toque ou clique para ver em tela cheia"
      >
        <img
          src={displayImage}
          alt={product.name || "Foto"}
          className="w-[400px] h-[500px] object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />

        {/* Indicador no canto superior direito - visível no mobile sem hover */}
        <div className="absolute top-2.5 right-2.5 bg-black/75 text-white text-[11px] font-medium px-2.5 py-1 rounded-full flex items-center gap-1.5 shadow-lg border border-white/20 backdrop-blur-sm opacity-90 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity duration-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3.5 w-3.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
            />
          </svg>
          <span>{t("common.fullscreen")}</span>
        </div>

        {/* Overlay central no hover para desktop */}
        <div className="hidden sm:flex absolute inset-0 bg-black/25 opacity-0 group-hover:opacity-100 transition-opacity duration-200 items-center justify-center pointer-events-none">
          <span className="bg-black/75 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-2 shadow-xl border border-white/20 backdrop-blur-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
              />
            </svg>
            {t("common.clickToExpand")}
          </span>
        </div>
      </figure>
      {isHome ? null : (
        <>
          <div className="bg-base-300 pt-[4px] text-[12px] font-thin pr-4 pb-1 text-end">
            {product.evento}
          </div>
          {isGift || isPublicView ? null : (
            <div className="flex justify-between items-center bg-base-300 p-4 pt-1">
              <div className="price text-2xl font-semibold">
                R$
                {(product.priceInCents / 100).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </div>

              <div className="card-actions">
                {quantity > 0 ? (
                  <button
                    className="btn btn-error"
                    onClick={handleRemoveFromCart}
                  >
                    {t("shop.removeFromCart")}
                  </button>
                ) : (
                  <button
                    className="btn btn-primary bg-blue-500 border-none"
                    onClick={handleAddToCart}
                  >
                    {t("shop.wantPhoto")}
                  </button>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ProductSingleCard;
